import * as S from './styles';
import Product from './ProductCard';
import { memo, useRef, useState, useEffect } from 'react';
import { CardMode, PackagesTypesProps, ProductProps, TaxSubstitutionProps } from '@/types';

export interface Props {
  product: ProductProps;
  direction?: CardMode;
  substTrib?: TaxSubstitutionProps[];
  handleModalFlex?: (product: ProductProps, selectedPack: PackagesTypesProps, selectedPackQty: number) => void;
  handleModalInfos?: (product: ProductProps, pack: PackagesTypesProps, packQuantity: number) => void;
  showFlex?: boolean;
  showInfos?: boolean;
  onProductNavigate?: () => void;
}

const ProductContent = ({
  product,
  substTrib,
  direction = 'grid',
  handleModalFlex,
  handleModalInfos,
  showFlex = true,
  showInfos = true,
  onProductNavigate,
}: Props) => {
  const [isVisible, setIsVisible] = useState(false);
  const [elementHeight, setElementHeight] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const productRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          if (productRef.current && !elementHeight) {
            setElementHeight(productRef.current.offsetHeight);
          }
          setIsVisible(false);
        }
      },
      {
        threshold: 0,
        rootMargin: '100px',
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [elementHeight]);

  useEffect(() => {
    if (isVisible && productRef.current && !elementHeight) {
      const height = productRef.current.offsetHeight;
      if (height > 0) {
        setElementHeight(height);
      }
    }
  }, [isVisible, elementHeight]);

  useEffect(() => {
    setElementHeight(null);
  }, [direction]);

  return (
    <S.ProductContainer ref={containerRef} id={`product-${product.COD_PRODUTO}`}>
      {isVisible ? (
        <div style={{ height: '100%' }} ref={productRef}>
          <Product
            key={`${product.COD_PRODUTO}`}
            direction={direction}
            substTrib={substTrib}
            product={product}
            handleModalFlex={handleModalFlex}
            handleModalInfos={handleModalInfos}
            showFlex={showFlex}
            showInfos={showInfos}
            onProductNavigate={onProductNavigate}
          />
        </div>
      ) : (
        <div style={{ height: elementHeight || 'auto', width: '100%' }} />
      )}
    </S.ProductContainer>
  );
};

export default memo(ProductContent);
